import type { NewWorkspace } from '@thinkalpha/ui-types/contracts/workspace';

export const DEFAULT_WIDGET_ACTIVE_BORDER_COLOR = '#4FF4FF';
export const ALTERNATIVE_WIDGET_ACTIVE_BORDER_COLOR = '#eab308';

export const defaultWorkspace: NewWorkspace = {
    name: 'New Workspace',
    containers: [],
    layoutSettings: {
        containerLayoutLocked: false,
        gridSnappingEnabled: true,
        enableMosaicLayout: false,
        mosaicGutterPx: 0,
    },
    description: '',
};

export const makeNamedDefaultWorkspace = (name: string): NewWorkspace => ({
    ...defaultWorkspace,
    name,
});
